import apiService from '@/services/apiService';

const actions = {
  getReportReferralPages({ commit }, formData) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/report-referral', formData)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReportReferrals({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('marketing/report-referral')
        .then((response) => {
          commit('getReportReferrals', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`marketing/report-referral/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getDetail', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSlideScreen({ commit }, payload) {
    apiService.post('marketing/report-referral/check-availability-slide-referral-before-create', payload)
      .then((response) => {
        commit('getSlideScreen', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSlideScreenEdit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/report-referral/check-availability-slide-referral-before-update', payload)
        .then((response) => {
          resolve(response.data.data);
          commit('getSlideScreen', response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  postReportReferral({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/report-referral', payload)
        .then((response) => {
          commit('postReportReferral', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateReportReferrals({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/report-referral/update-status', payload)
        .then((response) => {
          const object = {};
          payload.forEach((value, key) => { object[key] = value; });
          const json = JSON.stringify(object);
          commit('updateReportReferrals', json);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putReportReferral({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`marketing/report-referral/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putReportReferral', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delReportReferral({ commit }, payload) {
    apiService.delete(`marketing/report-referral/${payload}`)
      .then((response) => {
        commit('delReportReferral', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
